import { Button } from "antd";
import classNames from "classnames";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { IconTrash, LoadingIcon } from "../../common/Icons";
import './DeleteModal.scss';
import { toast } from "react-toastify";
import { deleteProspectClient } from "../../../api";
import { useSelector } from "react-redux";

export default function DeleteModal({ isOpen, setIsOpen, data }) {
  const { token, navCommunity } = useSelector((state) => state.auth);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    try {

      const res = await deleteProspectClient({
        token,
        organizationId: navCommunity.id,
        prospectClientId: data.id,
      });

      if (res.data.statusCode === 200) {
        toast.success("L'élément est supprimé avec succès.");
      } else {
        toast.error("Une erreur est survenue lors de la suppression des données.");
      }

    } catch (ex) {
      toast.error("Une erreur est survenue lors de l'enregistrement des données");
      console.error("Error saving data : ", ex);
    } finally {
      setIsDeleting(false);
      setIsOpen(false);
    }
  };


  return (
    <Dialog
      visible={isOpen}
      style={{ width: '440px' }}
      resizable={false}
      className="prospect_delete_modal"
      onHide={() => setIsOpen(false)}
      showHeader={false}
    >
      <div className="modal_content">
        <div className="modal_icon">
          <IconTrash size={20} />
        </div>
        <p className="modal_title">Supprimer</p>
        <p className="modal_text">Êtes-vous sûr de vouloir supprimer cet élément ?</p>
        <div className="buttons">
          <Button
            type="ghost"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Annuler
          </Button>
          <Button
            type="default"
            onClick={() => { if (!isDeleting) handleDelete() }}
            className={classNames({
              "form_btn_delete": true,
              "form_btn_delete_disabled": isDeleting
            })}
          >
            {isDeleting && (<LoadingIcon color="white" size={20} />)}
            Supprimer
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
